<template>
  <div class="home-wrapper">
    <AccountSettings />
    <v-icon @click="sign_out" class="logout"></v-icon>

    <v-container>
      <v-layout row align-start pb-1>
        <v-flex xs5>
          <ProfilePic
            :image="user_data.big_thumbnail"
            @upload="saveData"
            :accountActive="!user_data.accountNotActivated"
          />
        </v-flex>
        <v-flex @click="bottomSheet = 'view_profile'" xs7 pl-2 class="text-xs-left">
          <h3 class="name-with-settings">
            <span :title="user_data.name">{{ user_data.name }}</span>
            <v-icon ml-1>mdi-pencil</v-icon>
          </h3>
          <!-- <h4>{{ user_data.scoutarea }}</h4> -->
          <h4 class="header-thin">{{ user_data.working_for }}</h4>
          <h5>
            <flag class="flag" :iso="user_data.nationality" />
            {{ getNationality }}
          </h5>
        </v-flex>
      </v-layout>

      <v-layout mt-3 mb-1 align-start>
        <v-flex xs12 py-2 px-3 class="matches-box">
          <v-layout mb-2>
            <v-flex xs3>
              <h3>Matches</h3>
            </v-flex>
            <v-flex xs9 class="text-xs-right" style="font-size: 12px">
              <div class="mt-1">
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'all' }"
                  @click="selectedMatchType = 'all'"
                  >Alle</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'player' }"
                  @click="selectedMatchType = 'player'"
                  >Spieler</span
                >
                <span
                  class="d-inline-block filter-span"
                  :class="{ 'filter-span-active': selectedMatchType === 'trainer' }"
                  @click="selectedMatchType = 'trainer'"
                  >Trainer</span
                >
                <span
                  class="d-inline-block"
                  :class="{ 'filter-span-active': selectedMatchType === 'teams' }"
                  @click="selectedMatchType = 'teams'"
                  >Vereine</span
                >
              </div>
            </v-flex>
          </v-layout>
          <div
            v-if="filteredUserMatches && filteredUserMatches.length"
            class="column-wrapper-flexbox"
            style="margin-top: 10px"
          >
            <MatchPreview
              @click="openMatchedProfile(match)"
              class="player-preview"
              v-for="match in filteredUserMatches"
              :key="match.chat_id"
              :picture="
                match.player_id === user_data.id ? match.logo : match.profile_pic
              "
              :msg="match.lastMessage"
              :chat-id="match.chat_id"
              :name="match.player_id === user_data.id ? match.team : match.player_name"
              :details="match.contactDetails"
              :showRemoveButton="true"
              :selectedMatch="match"
            ></MatchPreview>
          </div>
          <v-flex my-3 v-else class="text-xs-center">
            <v-icon large color="white">mdi-volleyball</v-icon>
            <h4 style="color: white">Aktuell keine Matches vorhanden.</h4>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- edit profile -->
    <v-card
      :class="['bottom-sheet', { active: bottomSheet !== 'hidden' ? true : false }]"
    >
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div v-if="bottomSheet === 'profile_settings'" class="settings">
        <v-tabs
          class="tabs"
          fixed-tabs
          background-color="white"
          slider-color="light-green accent-4"
        >
          <v-tab href="#Scoutdaten">Scoutdaten</v-tab>
          <v-tab href="#Scouted">Gescoutet</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>

          <v-tabs-items v-model="tab_mehr" :touchless="true">
            <v-tab-item :value="'Scouted'">
              <v-card class="overview-profile" flat>
                <v-list>
                  <v-list-group
                    v-for="(item, i) in user_data.history"
                    :key="i"
                    v-model="item.active"
                    no-action
                  >
                    <template v-slot:activator>
                      <div class="history-wrapper list-name">
                        <h2
                          v-text="`Spieler: ${item.name ? item.name : 'bitte angeben'}`"
                        ></h2>
                      </div>
                    </template>

                    <div class="history-content">
                      <v-icon
                        @click="deleteEntry(i)"
                        class="delete"
                        color="red"
                      ></v-icon>
                      <div class="history-column">
                        <label>Vor- und Nachname</label>
                        <v-text-field color="green" v-model="item.name"></v-text-field>
                        <div class="history-column">
                          <label>Altersklasse</label>
                          <v-select
                            :items="$store.state.age_classes"
                            color="green"
                            v-model="item.class"
                          ></v-select>
                        </div>
                        <div class="history-column">
                          <label>Geschlecht</label>
                          <v-select
                            :items="$store.state.sex"
                            color="green"
                            v-model="item.sex"
                          ></v-select>
                        </div>
                        <label>Region/Verband</label>
                        <v-select
                          color="green"
                          :items="$store.state.verband"
                          v-model="item.verband"
                          solo
                        ></v-select>
                        <label>Liga</label>
                        <v-select
                          v-if="item.verband"
                          color="green"
                          :items="$store.state.filter_leagues[item.verband]"
                          item-text="league"
                          item-value="category"
                          return-object
                          v-model="item.category"
                          solo
                        ></v-select>
                        <label>Aktueller Verein</label>
                        <v-text-field
                          color="green"
                          v-model="item.team_name"
                        ></v-text-field>
                        <div class="history-column">
                          <label>Position</label>
                          <v-select
                            :items="$store.state.positions_extended"
                            color="green"
                            v-model="item.player_position"
                          ></v-select>
                        </div>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
                <v-btn
                  @click="user_data.history.push({ season: null })"
                  class="primary-btn"
                  >Neuer Eintrag</v-btn
                >
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Scoutdaten'">
              <v-card class="overview-profile" flat>
                <label>Vor- u. Nachname</label>
                <v-text-field
                  color="green"
                  v-model="user_data.name"
                  solo
                ></v-text-field>
                <label>Geburtsdatum</label>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  color="green"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      solo
                      color="green"
                      v-model="formatDate"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="green"
                    ref="picker"
                    v-model="user_data.age"
                    :max="new Date().toISOString().substr(0, 10)"
                    min="1950-01-01"
                  ></v-date-picker>
                </v-menu>

                <label>Geschlecht</label>
                <v-select
                  color="green"
                  :items="sex"
                  v-model="user_data.sex"
                  solo
                ></v-select>

                <label>Nationalität</label>
                <v-autocomplete
                  :no-data-text="'Keine Einträge vorhanden'"
                  :items="$store.state.nationalities"
                  item-text="item_text"
                  item-value="id"
                  color="green"
                  name="nationalities"
                  v-model="user_data.nationality"
                  solo
                  attach
                ></v-autocomplete>

                <label>Wohnsitz (Land)</label>
                <v-autocomplete
                  :items="$store.state.countries"
                  color="green"
                  v-model="user_data.living_in_country"
                  solo
                  attach
                ></v-autocomplete>

                <label>Sprachen</label>
                <v-select
                  v-model="user_data.languages"
                  color="green"
                  :items="$store.state.languages"
                  attach
                  chips
                  multiple
                ></v-select>
                <label>Scoutgebiet</label>
                <v-select
                  color="green"
                  :items="$store.state.scoutarea"
                  v-model="user_data.scoutarea"
                  solo
                  multiple
                ></v-select>
                <label>Scoutbereich</label>
                <v-select
                  color="green"
                  :items="$store.state.scout_segment"
                  v-model="user_data.bundesland"
                  solo
                  multiple
                ></v-select>

                <label>Tätig für</label>
                <v-text-field
                  placeholder="Vereins-, Unternehmens- oder Agenturname "
                  color="green"
                  v-model="user_data.working_for"
                  solo
                ></v-text-field>

                <div>
                  <label> Tätig seit </label>
                  <v-menu
                    ref="since_menu"
                    v-model="since_menu"
                    locale="de"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        color="green"
                        v-model="formatSinceDate"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        solo
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="green"
                      locale="de"
                      v-model="user_data.working_since"
                      type="month"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        min="1900-01-01"
                        :max="new Date().toISOString().substr(0, 10)"
                        color="green white--text"
                        @click="$refs.since_menu.save(user_data.working_since)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-menu>
                </div>

                <h2>Links</h2>
                <label for>Link Transfermarkt-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.transfermarkt"
                  hint="Kopiere den Link von deinem Transfermarkt-Profil."
                  solo
                ></v-text-field>

                <label>Link Facebook-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.facebook"
                  hint="Kopiere den Link von deinem Facebook-Profil."
                  solo
                ></v-text-field>

                <label>Link Instagram-Profil (optional)</label>
                <v-text-field
                  color="green"
                  v-model="user_data.instagram"
                  hint="Kopiere den Link von deinem Instagram-Profil."
                  solo
                ></v-text-field>

                <label>Link Website (optional)</label>
                <v-text-field
                  hint="Kopiere die URL der Website."
                  color="green"
                  v-model="user_data.website"
                  solo
                ></v-text-field>
                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h2>Mehr Infos</h2>
                    </template>
                    <label>Bio</label>
                    <v-textarea
                      placeholder="Was zeichnet dich als Talentscout aus?"
                      color="green"
                      v-model="user_data.bio"
                      solo
                    />
                    <label>Geburtsort</label>
                    <v-text-field
                      color="green"
                      v-model="user_data.birthplace"
                      solo
                    ></v-text-field>

                    <label>Bundesland</label>
                    <v-text-field
                      color="green"
                      v-model="user_data.living_in_state"
                      solo
                    ></v-text-field>
                  </v-list-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <GalleryTab @save-data="saveImage" />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
      <!-- <div v-if="bottomSheet=== 'search_settings'" class="settings">
        <label>Liga</label>
        <v-select
          color="green"
          :items="$store.state.leagues"
          v-model="user_data.search_league"
          solo
        ></v-select>
      </div> -->
    </v-card>

    <!-- profile show -->
    <v-card
      :class="[
        'bottom-sheet',
        {
          active:
            bottomSheet !== 'hidden' && bottomSheet == 'view_profile' ? true : false,
        },
      ]"
    >
      <v-icon @click="closeMenu" class="closeBtn">keyboard_backspace</v-icon>
      <div class="bottom-sheet-head">
        <h3>
          <flag class="flag" :iso="user_data.nationality" />
          {{ user_data.name }}
        </h3>
      </div>
      <div class="profile">
        <ScoutData :userData="user_data" />

        <v-tabs fixed-tabs background-color="white" slider-color="light-green accent-4">
          <v-tab href="#Scoutdaten">Scoutdaten</v-tab>
          <v-tab href="#Scouted">Gescoutet</v-tab>
          <v-tab href="#Gallery">Galerie</v-tab>
          <v-tabs-items v-model="tab">
            <v-tab-item :value="'Scoutdaten'">
              <div class="overview-profile" flat>
                <div class="flex-row-wrap">
                  <div>
                    <label>Sprachen</label>
                    <div
                      class="no-margin"
                      v-for="(language, i) in user_data.languages"
                      :key="i"
                    >
                      {{ language }}
                    </div>
                  </div>
                </div>
                <v-list>
                  <v-list-group no-action>
                    <template v-slot:activator>
                      <h3>Mehr Infos</h3>
                    </template>

                    <div>
                      <div class="history-content">
                        <div class="flex-row-wrap">
                          <div>
                            <label>Geburtsort</label>
                            {{ user_data.birthplace }}
                          </div>
                          <div v-if="user_data.living_in_country">
                            <label>Bundesland</label>
                            {{ user_data.living_in_state }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-list-group>
                </v-list>
              </div>
            </v-tab-item>
            <v-tab-item :value="'Scouted'">
              <div class="overview-career" flat>
                <v-timeline v-if="user_data.history && user_data.history.length > 0">
                  <v-timeline-item
                    v-for="(history, i) in user_data.history"
                    :key="i"
                    color="light-green accent-4"
                    :right="i % 2 === 0"
                    :left="i % 2 === 1"
                    small
                  >
                    <HistoryCard :history="history" :side="i"></HistoryCard>
                  </v-timeline-item>
                </v-timeline>
                <div v-else class="history-content">
                  <h3>Bisher keine Talente angegeben.</h3>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item :value="'Gallery'">
              <v-card class="overview-career" flat>
                <div class="overview-profile" flat>
                  <div class="history-content">
                    <GalleryContent
                      v-if="hasPictures"
                      :images="bindedUserData.galleryImages"
                    />
                    <div v-else class="history-content">
                      <h3>Bisher keine Galerie angelegt.</h3>
                    </div>

                    <LinkCard
                      v-if="hasLinks"
                      :links="bindedUserData.videolinks"
                      :title="'Videos'"
                    />
                    <LinkCard
                      v-if="hasArticles"
                      :links="bindedUserData.newslinks"
                      :title="'Zeitungsartikel'"
                    />
                  </div>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </div>
      <div class="button-box-sticky">
        <button
          color="white"
          @click="bottomSheet = 'profile_settings'"
          class="menu-button main main-small mb-1"
        >
          <!-- <v-icon>edit</v-icon> -->
          PROFIL BEARBEITEN
        </button>
        <!-- <label class="label-big">Profil bearbeiten</label> -->
      </div>
    </v-card>

    <v-dialog v-model="accountNeedVerification" max-width="290">
      <v-card class="text-left">
        <v-card-title class="headline">Verifizierung Scoutaccount</v-card-title>

        <v-card-text
          >Damit auch du den begehrten <b>blauen C4T-Ring</b> für dein Profilbild
          erhältst, und somit einen bevorzugten Eindruck bei Talenten oder Vereinen
          erzeugst, musst du deinen Account nur noch verifizieren.</v-card-text
        >

        <v-card-actions style="justify-content: center">
          <v-btn color="blue white--text" text @click="verifyAccount"
            >Jetzt verifizieren</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MatchSheetPlayer
      v-if="showPlayer && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showPlayer = false"
      :show="showPlayer"
      :isApplication="true"
    ></MatchSheetPlayer>

    <MatchSheetTrainer
      v-if="showTrainer && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showTrainer = false"
      :show="showTrainer"
      :isApplication="true"
    ></MatchSheetTrainer>

    <MatchSheetTeam
      v-if="showTeam && selectedProfile.id"
      :selectedProfile="selectedProfile"
      @close="showTeam = false"
      :show="showTeam"
    ></MatchSheetTeam>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { db } from '@/db';
import HistoryCard from '@/components/HistoryCard';
import LinkCard from '@/components/settings/LinkCard';
import ProfilePic from '@/components/home/ProfilePic';
import GalleryContent from '@/components/settings/GalleryContent';
import AccountSettings from '@/components/settings/AccountSettings';
import MatchPreview from '../../components/home/MatchPreview';
import ScoutData from '../../components/profile/ScoutData';
import match from '../../mixins/match';
import MatchSheetPlayer from '@/components/match/PlayerSheet';
import MatchSheetTrainer from '@/components/match/TrainerSheet';
import MatchSheetTeam from '@/components/match/TeamSheet';
import GalleryTab from '../../components/settings/edit/GalleryTab';
import common from '../../mixins/common';

export default {
  name: 'home-scout',

  components: {
    HistoryCard,
    LinkCard,
    ProfilePic,
    GalleryContent,
    AccountSettings,
    MatchPreview,
    ScoutData,
    MatchSheetPlayer,
    MatchSheetTrainer,
    MatchSheetTeam,
    GalleryTab,
  },

  mixins: [match, common],

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'));
    },
  },

  data: () => ({
    initialData: {},
    dialog: false,
    menu: false,
    since_menu: false,
    tab: null,
    bottomSheet: 'hidden',
    profile_settings: false,
    search_settings: false,
    view_profile: false,
    tab_mehr: null,
    email: '',
    password: '',
    picture: '',
    uploading: false,
    select: { state: 'Florida', abbr: 'FL' },
    items: ['Profi', 'Amateur', 'Halbprofi'],
    foot: ['Rechts', 'Links', 'Beide'],
    sex: ['Männlich', 'Weiblich'],
    showTrainer: false,
    showPlayer: false,
    showTeam: false,
    selectedProfile: {},
  }),

  computed: {
    ...mapState(['user_data', 'userMatches', 'bindedUserData']),

    getNationality() {
      if (this.user_data.nationality) {
        const found = this.$store.state.nationalities.find(
          (element) => element.id === this.user_data.nationality,
        );
        return found.item_text;
      }
      return '';
    },
    formatDate() {
      if (!this.user_data.age) return null;

      const [year, month, day] = this.user_data.age.split('-');
      return `${day}.${month}.${year}`;
    },

    formatSinceDate() {
      return this.user_data.working_since
        ? moment(this.user_data.working_since).format('MM/YYYY')
        : '';
    },

    dateToAge() {
      if (!this.user_data.age) return null;
      const [year, month, day] = this.user_data.age.split('-');
      const dateString = `${year}-${month}-${day}`;
      const age = moment().diff(dateString, 'years');
      return age;
    },
  },

  methods: {
    async openMatchedProfile(matchChat) {
      console.log(matchChat);
      let collection;
      let type;

      this.selectedProfile = {};

      if (matchChat.contactDetails) {
        this.$store.state.loading = true;
        if (matchChat.contactDetails.type === 'teams') {
          collection = 'teams';
          type = 'showTeam';
        } else {
          collection =
            matchChat.contactDetails.type === 'trainer' ? 'trainers' : 'users';
          type =
            matchChat.contactDetails.type === 'trainer' ? 'showTrainer' : 'showPlayer';
        }
      }

      const contactedBy = await db
        .collection(collection)
        .doc(matchChat.player_id)
        .get({ source: 'server' })
        .then((snapshot) => snapshot.data());

      this.selectedProfile = contactedBy;
      this[type] = true;

      this.$store.state.loading = false;
    },

    closeMenu() {
      if (this.initialData === JSON.stringify(this.user_data)) {
      } else {
        this.saveData();
        this.initialData = JSON.stringify(this.user_data);
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Daten gespeichert',
        });
      }
      this.bottomSheet = 'hidden';
    },
    sign_out() {
      this.$store.state.logout_dialog = true;
    },
    saveImage() {
      db.collection('scouts')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
    saveData() {
      this.clearLinks();

      db.collection('scouts')
        .doc(this.user_data.id)
        .update({ ...this.user_data })
        .then(() => {
          this.$forceUpdate();
        });
    },
    deleteEntry(i) {
      const oldHistory = this.user_data.history;
      const remove = oldHistory[i];
      const filteredItems = oldHistory.filter((item) => item !== remove);
      this.$store.state.user_data.history = filteredItems;
    },
  },

  beforeMount() {
    this.initialData = JSON.stringify(this.$store.state.user_data);
  },

  created() {
    document.body.classList.add('main-background');
    this.accountNeedVerification = this.user_data.accountNotActivated;
  },
};
</script>
